<!-- conferenceInformation -->
<template>
  <div class="conferenceInformation">
    <mainPage :type="1"></mainPage>
  </div>
</template>

<script>
import mainPage from './components/mainPage'
export default {
  name: 'ConferenceInformation',
  data() {
    return {}
  },
  props: {},
  components: { mainPage },
  computed: {},
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped></style>
